function windowHeight() {
   var windowHeight = window.innerHeight;
   return windowHeight;
 } 
 function headerHeight() { 
   if(document.body.contains(document.querySelector('[data-site-header]'))) {
   const headerHeight = document.querySelector('[data-site-header]').offsetHeight;
   //console.log(headerHeight);
   return headerHeight;
   } else {
     return;
   }
 } 
 function cartFooter() {
   const cartFooterHeight = document.querySelector('.drawer__footer').offsetHeight;
   return cartFooterHeight;
 } 
 function announcementHeight() { 
   if(document.body.contains(document.querySelector('.announcement-bar-container'))) {
      const announcementHeight = document.querySelector('.announcement-bar-container').offsetHeight; 
      console.log(announcementHeight);
      if(announcementHeight == 0) {
         return 36;
      } else {
      return announcementHeight;
      }
      } else {
        return 0;
      } 
 }

function halfPageOffset() {
   if(document.body.contains(document.querySelector('.page-width'))) {
   const container = document.querySelector('.page-width');
   const offset = container.offsetLeft;
   return offset;

   }
}


 document.documentElement.style.setProperty('--window-height', windowHeight() + 'px'); 
 document.documentElement.style.setProperty('--header-height', headerHeight() + 'px');
 document.documentElement.style.setProperty('--half-page-offset', halfPageOffset() + 'px');
 document.documentElement.style.setProperty('--cart-footer-height', cartFooter() + 'px');
 document.documentElement.style.setProperty('--announcement-height', announcementHeight() + 'px');

window.addEventListener('resize', debounce(function() {
   document.documentElement.style.setProperty('--header-height', headerHeight() + 'px');
   document.documentElement.style.setProperty('--window-height', windowHeight() + 'px');
   document.documentElement.style.setProperty('--cart-footer-height', cartFooter() + 'px'); 
   document.documentElement.style.setProperty('--half-page-offset', halfPageOffset() + 'px');
   document.documentElement.style.setProperty('--announcement-height', announcementHeight() + 'px');
}, 50)); 

window.addEventListener('load', (event) => {
   document.documentElement.style.setProperty('--announcement-height', announcementHeight() + 'px');
 });
 

 /************ STICKY HEADER ***************/
 if ($('.site-header').length) {
 const siteHeader = document.querySelector('[data-site-header]');

    function fixHeader() {
       var header = $('.site-header');
       var stickyOffset = $('.site-header').offset().top; 
       $('body').addClass('fixed-header');

       $(window).scroll(debounce(function () {
        // console.log('scroll');
          checkHeader(stickyOffset);
       }, 50));

       function checkHeader(stickyOffset) { 
          scroll = $(window).scrollTop();
           //console.log(stickyOffset,'offset');
           //console.log(scroll, 'Scroll');
          if (scroll > stickyOffset ) {
            if(!header.hasClass('scrolling','fixed')) {
           // console.log('add scrolling/fixed');
             header.addClass('scrolling');
             header.addClass('fixed');
            }
          } else {
            if(header.hasClass('scrolling','fixed')) {
           // console.log('remove scrolling/fixed');
             header.removeClass('scrolling');
             header.removeClass('fixed');
            }
          }
       }
    }

    window.addEventListener('resize', debounce(function() { 
       fixHeader();
    }, 50));  

    window.addEventListener('load', (event) => { 
      fixHeader();
   });
 } 
 
/***************** SLIDE TOGGLES *******************/  
document.body.addEventListener('click', slideToggle); 
function slideToggle(event){
   const toggle = event.target;
   if(event.target.dataset.toggleTarget) { 
   const target = toggle.dataset.toggleTarget; 
   const toggleContainer =  document.querySelectorAll(`[data-tab-content="${target}"]`);
   const toggleClass = (toggle, className) => toggle.classList.toggle(className);
   toggleClass(toggle, 'active');  
 
   toggleContainer.forEach((group) => { 
      //console.log(group, 'GROUP');
       if (!group.classList.contains('active')) {
         group.classList.add('active'); 
         group.style.height = 'auto'; 
         const height = group.clientHeight + 'px'; 
         group.style.height = '0px'; 
 
         setTimeout(function () {
           group.style.height = height;
         }, 0);
         group.addEventListener('transitionend', function () {
           group.style.height = 'auto';
         },{
           once: true
         }); 
       } else { 
         group.style.height = 'auto'; 
         const height = group.clientHeight + 'px'; 
        // console.log(height, "height");
         group.style.height = height;
         setTimeout(function () {
           group.style.height = '0px';  
         }, 0); 
         
         group.addEventListener('transitionend', function () { 
           group.classList.remove('active');
         },{
           once: true
         }); 
       } 
     });  
   }
}  
 /*************** TAB TOGGLES ***********/
 document.querySelectorAll('[data-tab-target]').forEach((tab) => { 
   tab.addEventListener('click', (e) => {
      
     const target = tab.dataset.tabTarget;
     const tabGroup = tab.dataset.tabGroup;
     //console.log(target,"TARGET"); 
    // console.log(tabGroup,"TAB GROUP"); 
     const tabGroups = document.querySelectorAll(`[data-tab-group="${tabGroup}"]`); 
     tabGroups.forEach((group) => {
       group.classList.remove('active');
     }); 
     tab.classList.add('active');
     document.querySelectorAll(`[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`).forEach((group) => {
       group.classList.add('active');
     }); 
   });
 });
  
 
// MODAL TOGGLING 
document.querySelectorAll('[data-modal-target]').forEach((btnOpen) => {   
   btnOpen.onclick = function(event) {  
     const target = btnOpen.dataset.modalTarget; 
     const modalContent = document.querySelector(`[data-modal-content="${target}"]`);  
     const closeModal = modalContent.querySelector('[data-close]'); 
     const modalSlider = modalContent.querySelector('.bd-slider'); 
     event.preventDefault();
     console.log('open modal');
     modalContent.classList.add('active'); 
 
     document.querySelector('body').classList.add('overflow-hidden');   
     closeModal.onclick = function() {
     //  console.log('close modal');
       modalContent.classList.remove('active');
       document.querySelector('body').classList.remove('overflow-hidden');  
     } 
     window.onclick = function(event) { 
     // console.log(event);
       if (event.target == modalContent) {
        // console.log('close modal'); 
    
         modalContent.classList.remove('active');
         document.querySelector('body').classList.remove('overflow-hidden');  
    
       }
     }   
     window.addEventListener('keyup', function(e) {
         if(e.code === 'Escape') {
           modalContent.classList.remove('active');
           document.querySelector('body').classList.remove('overflow-hidden');
         }
     }); 
 
     if(modalSlider) {
      const slider = new Flickity(modalSlider);
       console.log('resize slider');
       slider.resize();
     }
 }  
  
 });
  

 /************* PRODUCT PAGE SCRIPTS ****************/
 $('[data-calculator-toggle]').on('click', function (e) {
    e.preventDefault();
    var target = $(this).data('calculator-toggle');
    $('[data-calculator="' + target + '"]').addClass('active');
 })

 $('[data-feeding-calc-submit]').on('click', function (e) {
    e.preventDefault();
    var container = $(this).closest('[data-calculator]');
   //console.log('results');
    $('[data-calculations-area]', container).hide();
    $('[data-feeding-calc-results]', container).show();
    var age = $('input[name="age"]:checked', container).val();
     console.log('AGE', age);
    var active = 1;
    if (age == 1) {
       active = $('input[name="activity"]:checked', container).val();
    }
    //console.log('active', active);

    var weight = $('select[name="weight"]', container).val();
     console.log('weight', weight);
    var cupsInBag = $('[data-cups-bag]', container).val();
     console.log('cups', cupsInBag);
    var bagsNeeded = (weight * 7 / cupsInBag * active * age).toFixed(1); 
    var bagsNeededSplit = bagsNeeded.toString().split('.');

     //console.log('bagsNeeded', bagsNeeded);

    var cupsPerDay = (weight * active * age).toFixed(1);
    

    var cupsPerDaySplit = cupsPerDay.toString().split('.');

    //console.log(cupsPerDaySplit[1]);
    let cupsWhole;


    function buildWhole(whole) {
       if (parseInt(whole) == 0) {
          cupsWhole = ''
       } else {
          cupsWhole = parseInt(whole);
       }
       return cupsWhole;
    }

    function buildFraction(fraction) {
       let fractionAmount;
       switch (parseInt(fraction)) {
          case 0:
             fractionAmount = '';
             break;
          case 1:
             fractionAmount = '<sup>1</sup>&frasl;<sub>4</sub>';
             break;
          case 2:
             fractionAmount = '<sup>1</sup>&frasl;<sub>4</sub>';
             break;
          case 3:
             fractionAmount = '<sup>1</sup>&frasl;<sub>3</sub>';
             break;
          case 4:
             fractionAmount = '<sup>1</sup>&frasl;<sub>2</sub>';
             break;
          case 5:
             fractionAmount = '<sup>1</sup>&frasl;<sub>2</sub>';
             break;
          case 6:
             fractionAmount = '<sup>2</sup>&frasl;<sub>3</sub>';
             break;
          case 7:
             fractionAmount = '<sup>2</sup>&frasl;<sub>3</sub>';
             break;
          case 8:
             fractionAmount = '<sup>3</sup>&frasl;<sub>4</sub>';
             break;
          case 9:
             fractionAmount = '<sup>3</sup>&frasl;<sub>4</sub>';
       }
       return fractionAmount;
    } 
    $('[data-cups-per-day]', container).html(buildWhole(cupsPerDaySplit[0]) + ' ' + buildFraction(cupsPerDaySplit[1]));
    $('[data-bags-per-week]', container).html(buildWhole(bagsNeededSplit[0]) + ' ' + buildFraction(bagsNeededSplit[1]));

 });


 function resetCalculator(e) { 
    $('[data-calculations-area]').show();
    $('[data-feeding-calc-results]').hide();
 }


 $('[data-reset-calculator]').on('click',function(e){
   resetCalculator();
 })


 function getUrlParameter(sParam) {
   var sPageURL = window.location.search.substring(1),
     sURLVariables = sPageURL.split('&'),
     sParameterName,
     i;
 
   for (i = 0; i < sURLVariables.length; i++) {
     sParameterName = sURLVariables[i].split('=');
 
     if (sParameterName[0] === sParam) {
       return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
     }
   }
 };


// INTERCOM CHAT 

const chatButtons =  document.querySelectorAll('[data-chat]');

chatButtons.forEach((chatOpen) => {   
   chatOpen.onclick = function(event) {  

  if(window.screen.width > 749) {
     if(chatOpen.classList.contains('active')){
       Intercom('hide');
       chatButtons.forEach((chatOpen) => {   
       chatOpen.classList.remove('active');
       });
     } else {
       Intercom('show');
       chatButtons.forEach((chatOpen) => {   
       chatOpen.classList.add('active');
       });
     }
  } else {
   Intercom('show');
   }
 }
 }); 
 


 const openCart = getUrlParameter('cart'); 
 if(openCart == 'open' ) {
  window.addEventListener('load', function() {
   console.log(openCart,'cartURL');
   document.getElementById('cart-icon-bubble').click();
   });
 }

 const openCalc = getUrlParameter('calc');
 if(openCalc == 'open' ){
   $('[data-modal-target="calc"]').click();
 }

 const openMenu = getUrlParameter('menu');
 if(openMenu == 'open' ){
   $('[data-modal-target="food-menu"]').click();
 }
  
 
 window.addEventListener('load', function() {
   console.log('Page is loaded');
   $('product-form').addClass('active');
});
 


 

